export const sidebarLinkClickedTrackingLabel = "Q&P: QV Sidebar Click";
export const filterSearchTrackingLabel = "Q&P: QW Search Text";
export const policyAlertCopy = `This newly bound policy does not yet support direct updates,
please try again in a few minutes after it has been
registered.`;

export const policyIdRequiredError =
  "Policy ID is required to get enrollment status";
export const optimizationsNotReadyMessage = `Optimizations are not yet available.
Please try again in a few minutes.`;
export const optimizationsDefaultErrorMessage = `There was an error while loading optimizations.
Please reload and try again.
`;
